import { Component, HostListener, Input } from "@angular/core";
import {
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
  MediaViewModel,
  ProductViewModelBase,
} from "src/domain/client";
import SettingNames from "src/domain/extentions/setting-names";

@Component({
  selector: "vw-image-carousel",
  templateUrl: "./image-carousel.component.html",
})
export class ImageCarouselComponent {
  constructor() {}
  @Input() images: MediaViewModel[] = [];
  @Input({ required: true }) product!: ProductViewModelBase;
  @Input({ required: true }) productMessages!: string[];

  mediaCategoryTypeNames = MediaCategoryTypeNameEnum;
  mediaTypes = MediaTypeNameEnum;
  settingNames = SettingNames;

  activeImage = 0;
  activeLightboxImage = 0;

  lightboxOpen = false;

  @HostListener("document:keydown.escape", ["$event"])
  onKeydownHandler(): void {
    if (this.lightboxOpen) {
      this.toggleLightbox();
    }
  }

  handleClick(index: number): void {
    this.activeImage = index;
  }

  next(): void {
    if (this.activeImage === this.images.length - 1) {
      this.activeImage = 0;
    } else {
      this.activeImage++;
    }
  }

  prev(): void {
    if (this.activeImage === 0) {
      this.activeImage = this.images.length - 1;
    } else {
      this.activeImage--;
    }
  }

  toggleLightbox(): void {
    this.activeLightboxImage = this.activeImage;
    this.lightboxOpen = !this.lightboxOpen;
  }

  nextLightbox(): void {
    if (this.activeLightboxImage === this.images.length - 1) {
      this.activeLightboxImage = 0;
    } else {
      this.activeLightboxImage++;
    }
  }

  prevLightbox(): void {
    if (this.activeLightboxImage === 0) {
      this.activeLightboxImage = this.images.length - 1;
    } else {
      this.activeLightboxImage--;
    }
  }
}
